export default __webpack_public_path__ + "static/media/ShiftsCancelled.66f362a5.svg";